module.exports = __webpack_public_path__ + "media/images/dashboards/monitoring-4e54142aef8d79a628994dbc6968cf8d.png";